import { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Dialog, Transition } from '@headlessui/react';
import type { ReactNode } from 'react';

// Components
import MenuSidebarHeader from './MenuSidebarHeader';
import MenuSidebarMain from './MenuSidebarMain';
import MenuSidebarSettings from '@/components/composite/MenuMobile/MenuSidebarSettings';
import MenuHomeItem from '@/components/composite/Menu/MenuHomeItem';

const MenuSidebar = ({
    isOpenMenu,
    toggleMenu
}: Pick<SidebarWrapperPropsType, 'isOpenMenu' | 'toggleMenu'>) => {
    return (
        <MenuSidebar.Wrapper isOpenMenu={isOpenMenu} toggleMenu={toggleMenu}>
            <div className="navigation-menu w-[236px]">
                <div className="mb-12 px-8">
                    <MenuSidebarHeader />
                </div>
                <MenuHomeItem isMobile={true} />
                <div className="px-8">
                    <MenuSidebarMain />
                </div>
                <div className="my-8">
                    <hr className="border-t-1 w-full border-icoGray-300 dark:border-icoDarkMode-beton" />
                </div>
                <div className="px-8">
                    <MenuSidebarSettings />
                </div>
            </div>
        </MenuSidebar.Wrapper>
    );
};

type SidebarWrapperPropsType = {
    isOpenMenu: boolean;
    toggleMenu: () => void;
    children: ReactNode;
};

const SidebarWrapper = ({ isOpenMenu, toggleMenu, children }) => {
    return (
        <Transition.Root show={isOpenMenu} as={Fragment}>
            <Dialog
                as="div"
                static
                className="fixed inset-0 z-50 overflow-hidden"
                open={isOpenMenu}
                onClose={toggleMenu}>
                <div className="absolute inset-0 overflow-hidden">
                    <div className="fixed inset-y-0 left-0 flex max-w-full">
                        <Transition.Child
                            as={Fragment}
                            enter="transform transition ease-in-out duration-500 sm:duration-700"
                            enterFrom="-translate-x-full backdrop-blur-sm"
                            enterTo="translate-x-0 backdrop-blur-sm"
                            leave="backdrop-blur-sm transform transition ease-in-out duration-500 sm:duration-700"
                            leaveFrom="translate-x-0"
                            leaveTo="-translate-x-full">
                            <Dialog.Panel className="w-60">
                                <div className="flex h-full flex-col rounded-br-lg rounded-tr-lg border border-white bg-white/80 py-1 shadow-icoXL backdrop-blur-sm firefox:bg-gradient-to-tr firefox:from-icoGrayFirefox-300 firefox:to-icoWhiteFirefox dark:border-icoDarkMode-deepBlack dark:bg-icoDarkMode-deepBlack/80 dark:firefox:from-icoDarkMode-deepBlack dark:firefox:to-icoDarkMode-anthracite">
                                    <div className="scrollbar overflow-x-hidden py-7">
                                        {children}
                                    </div>
                                </div>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition.Root>
    );
};

SidebarWrapper.propTypes = {
    isOpenMenu: PropTypes.bool.isRequired,
    toggleMenu: PropTypes.func.isRequired,
    children: PropTypes.node.isRequired
};

MenuSidebar.Wrapper = SidebarWrapper;

export default MenuSidebar;
